import { render, staticRenderFns } from "./AdditionalChildInfo.vue?vue&type=template&id=0dcfcf4a&scoped=true&"
import script from "./AdditionalChildInfo.vue?vue&type=script&lang=ts&"
export * from "./AdditionalChildInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalChildInfo.vue?vue&type=style&index=0&id=0dcfcf4a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcfcf4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCol,VRow,VSlideYTransition})
